export var Comparison;
(function (Comparison) {
    Comparison[Comparison["Less"] = -1] = "Less";
    Comparison[Comparison["Greater"] = 1] = "Greater";
    Comparison[Comparison["Equal"] = 0] = "Equal";
})(Comparison || (Comparison = {}));
export function compare(a, b) {
    'use strict';
    if (a == b) {
        return 0;
    }
    if (Object.is(a, b)) {
        return 0;
    }
    if (a == null) {
        return -1;
    }
    if (b == null) {
        return 1;
    }
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    if (isNan(a)) {
        return -1;
    }
    if (isNan(b)) {
        return 1;
    }
    return 0;
}
function isNan(n) {
    return Number.isNaN(+n);
}
